import { Position } from '@/types/generated/common/trading'
import { InstrumentType } from '@/types/generated/common/types'

/*
 * Deribit-style symbols (e.g. BTC-PERPETUAL, BTC-28JUN-C) are Inverse.
 * Symbols with '_' in the base segment (e.g. BTC_USDC-PERP) are Linear.
 */
export function isInverse(symbol: string): boolean {
  const basePart = symbol.split('-')[0]
  return !basePart.includes('_')
}

export function isPerpetual(symbol: string): boolean {
  return symbol.includes('PERPETUAL') || symbol.includes('-PERP')
}

export function isOption(position: Position | { strike?: string }): boolean {
  return !!(position.strike && position.strike !== '0')
}

export function isFuture(
  position: Position | { symbol: string; expiry?: string; strike?: string }
): boolean {
  const sym = 'symbol' in position ? position.symbol : ''
  const perp = isPerpetual(sym)
  const opt = isOption(position as any)
  const exp = position.expiry
  return !!(exp && exp !== '0' && exp !== 'infinite' && !opt && !perp)
}

export function isInversePerpOrFuture(position: Position): boolean {
  if (!isInverse(position.symbol)) return false
  return isPerpetual(position.symbol) || isFuture(position)
}

// Metadata-first inverse check: trust the instrument's declared type when present
// (HL's prefixed symbols like HL-BTC-PERP defeat the string heuristic). Falls back
// to isInverse() only when the instrument or its type is unavailable.
export function isInverseInstrument(
  symbol: string,
  instrument?: { type?: InstrumentType } | null
): boolean {
  const type = instrument?.type
  if (type === InstrumentType.INSTRUMENT_TYPE_LINEAR) return false
  if (type === InstrumentType.INSTRUMENT_TYPE_INVERSE) return true
  return isInverse(symbol)
}

// Normalizes instrument kind variants to a canonical string for equality checks.
// 'perps' / 'perp' / 'future' / '2' (InstrumentKind enum value) all map to 'derivative'.
export function normalizeInstrumentKind(kind: string): string {
  return kind === 'perps' || kind === 'perp' || kind === 'future' || kind === '2'
    ? 'derivative'
    : kind
}
